import { Component, Inject, Input, OnChanges, OnInit, Optional, SimpleChanges } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { TT_VIEW_NAVIGATOR, TTViewNavigator } from '@app/modal/state-modal/state-modal.component';

@Component({
    selector: 'tt-po-connected-positions',
    templateUrl: './po-connected-positions.component.html',
    styleUrls: ['./po-connected-positions.component.css'],
    standalone: false,
})
export class PoConnectedPositionsComponent implements OnInit, OnChanges {
    @Input()
    public params?: GetPoConnectedPositionsParams;

    public grid?: GridOptions;

    constructor(@Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator) {}

    public readGrid() {
        if (!this.params) return;

        if (!this.grid) {
            this.grid = new Grid().setRememberId('w_poconnectedpositions.grid').setLoadDataFunction({ method: 4060, parameters: this.params });
        } else {
            this.grid.gridfunc?.read();
        }
    }

    private async init() {
        if (!this.params) throw Error('No parameters');

        this.readGrid();
    }

    ngOnInit(): void {
        if (!!this.navigator) {
            this.navigator.setSize?.({ width: '95vw', height: '98vh' });
            this.navigator.setHeading?.('p2_m_poconnectedpositions', true);
            this.params = this.navigator.params as any;
            this.init();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['params']) {
            this.init();
        }
    }
}

export interface GetPoConnectedPositionsParams {
    po_keyno: string | number;
}
